import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { setBusiness } from "store/actions/businessAction";
import HeaderLogo from "../../assets/images/appLogo.svg";
import { ProfileDropdown } from "./components/ProfileDropdown";
import { CloudIComponents } from "./components/CloudIComponents";
import { CurrencyDropdown } from "./components/CurrencyDropDown";
import NotificationsPopover from "./components/NotificationsPopover";
import NotificationBox from "components/simple/NotificationBox";
import SecurityPopover from "./components/SecurityPopover";
import {appSetExpandedNotification, appSetFiscalYear, appSetFiscalYears, setSecretView} from "store/actions/appAction";
import GuidesComponents from "./components/GuidesComponents";
import { SecretIcon } from "./iconComponents/IcSecret";
import BasicButton from "components/BasicInputs/BasicButton";
import UserIcon from "assets/icons/invoice/UserIcon";

function Header({ showGuid, closeGuide, activeGuide = true }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // const [showSideNotification, setShowSideNotification] = useState(false);

  const { firstName, lastName, userRole } = useSelector(
    (state) => state.appReducer?.user ?? { firstName: "", lastName: "", userRole: "" }
  );
  const { notifications } = useSelector((state) => state.notificationReducer);
  const unreadNotification = notifications?.filter((item) => item?.is_read === false) ?? [];
  const { business } = useSelector((state) => state).businessReducer;
  const { businessCurrencies } = useSelector((state) => state).currencyReducer;
  const { secretView } = useSelector((state) => state).appReducer;
  const appState = useSelector((state) => state).appReducer;
  const notificationExpanded = appState?.notificationExpanded;
  const isDemo = appState?.isDemo;

  const toggleSideNotification = () => {
    dispatch(appSetExpandedNotification(!notificationExpanded));
  };

  return (
    <>
      <div dir="ltr">
        <div className={notificationExpanded ? "active-panel-notif" : "panel-notif"}>
          <NotificationBox showSideNotif={notificationExpanded} toggleNotif={toggleSideNotification} />
        </div>
      </div>
      <div
        id="main-header"
        className="fixed flex w-screen top-0 right-0 bg-[#FEFEFE] h-16 z-10  drop-shadow-3xl p-5 flex-row items-center"
      >
        <div className="flex flex-row items-center">
          <a
            href="/"
            onClick={(e) => {
              dispatch(setBusiness(null));
                dispatch(appSetFiscalYears([]));
                dispatch(appSetFiscalYear(null));
              navigate("./");
              e.preventDefault();
            }}
          >
            <img alt="logo" src={HeaderLogo} />
          </a>
          <CloudIComponents />
        </div>
        <div className="flex flex-row-reverse items-center justify-start flex-1">
          {isDemo ? (
            <BasicButton
              variant="contained"
              onClick={() => (window.location.href = "/auth/logout")}
              className="min-h-[36px]"
            >
              <span className="text-sm">ثبت نام</span>
              <UserIcon color="#fff" scale={0.7} />
            </BasicButton>
          ) : (
            <ProfileDropdown name={firstName + " " + lastName} role={userRole} />
          )}
          {business && business.token && businessCurrencies && businessCurrencies?.length > 0 && (
            <CurrencyDropdown name={firstName + " " + lastName} role={userRole} />
          )}
          {business && business.token && (
            <NotificationsPopover
              badge={unreadNotification?.length ?? 0}
              openNotificationDrawer={() => toggleSideNotification()}
            />
          )}
          {business && business.token && (
            <SecurityPopover
              secret={secretView}
              icon={<SecretIcon status={secretView} />}
              onChangeSecret={() => {
                dispatch(setSecretView(!secretView));
              }}
            />
          )}
          {showGuid && (
            <GuidesComponents
              openGuideDrawer={() => {
                closeGuide();
              }}
              activeGuide={activeGuide}
            />
          )}
        </div>
      </div>
    </>
  );
}

export default Header;
